// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"433":"8748b7e4","453":"7ed73881","455":"a2cae4ea","687":"e56ff9ac","977":"d1107e7f"}[chunkId] + ".chunk.js";
};